// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsFilterBox_card__30P-V","warning-letter-filter-wrapper":"NewsFilterBox_warning-letter-filter-wrapper__2E0rN"};